// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__1djWR","column":"styles_column__Oi68S","align":"styles_align__LjPf8","img":"styles_img__cv_fD","columnImage":"styles_columnImage__4qCgk"};